var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCulturalFlavors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.837,
    height: 16.795,
    viewBox: "0 0 16.837 16.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cultural_Flavors_",
    "data-name": "Cultural Flavors ",
    transform: "translate(950.65 -1490.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cultural_Flavors_2",
    "data-name": "Cultural Flavors ",
    d: "M21.73,4.633a.457.457,0,0,0-.646,0L15.741,9.976c-.637.212-1.978.67-3.441,1.243-1.014.4-2.086.849-3.021,1.314a9.374,9.374,0,0,0-2.227,1.413,5.3,5.3,0,0,0-1.688,3.706,3.227,3.227,0,0,0,3.364,3.343,5.338,5.338,0,0,0,3.639-1.588,8.746,8.746,0,0,0,1.446-2.226,54.658,54.658,0,0,0,2.579-6.561L21.73,5.28A.458.458,0,0,0,21.73,4.633ZM10.454,17.44A12.046,12.046,0,0,1,8.4,19.074a5.477,5.477,0,0,1-.861.438,1.8,1.8,0,0,1-.609.142.469.469,0,0,1-.15-.02.159.159,0,0,1-.066-.039.156.156,0,0,1-.035-.062.434.434,0,0,1-.019-.136,1.693,1.693,0,0,1,.148-.6,9.666,9.666,0,0,1,2.161-2.887,23.3,23.3,0,0,1,1.89-1.574c1.169-.9,2.556-1.885,3.648-2.647l.6-.414c-.457.677-1.052,1.544-1.684,2.429-.528.741-1.082,1.493-1.6,2.152A17.062,17.062,0,0,1,10.454,17.44ZM7.477,14.383a8.88,8.88,0,0,1,2.073-1.3,45.926,45.926,0,0,1,4.413-1.836l.242-.087c-.379.265-.795.557-1.226.864-.825.588-1.706,1.23-2.494,1.835A23.8,23.8,0,0,0,8.54,15.475,12.636,12.636,0,0,0,6.75,17.615a5.962,5.962,0,0,0-.51.954c-.025.062-.047.122-.067.183a3.025,3.025,0,0,1-.2-1.1A4.7,4.7,0,0,1,7.477,14.383Zm5.618,2.861a7.305,7.305,0,0,1-1.154,1.725,4.735,4.735,0,0,1-3.214,1.416,3.055,3.055,0,0,1-1.186-.23c.069-.022.14-.046.212-.074a10.3,10.3,0,0,0,3.124-2.2,19.488,19.488,0,0,0,1.647-1.937c.918-1.194,1.913-2.612,2.675-3.728-.264.741-.584,1.6-.935,2.461C13.9,15.576,13.5,16.479,13.095,17.244Z",
    transform: "translate(-955.864 1486.19)",
    stroke: "#231f20",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulturalFlavors);
export default __webpack_public_path__ + "static/media/Cultural-Flavors.e6508bad193461334d35d47134397335.svg";
export { ForwardRef as ReactComponent };